import { render, staticRenderFns } from "./Staff05.vue?vue&type=template&id=3e8a8f46&"
import script from "./Staff05.vue?vue&type=script&lang=js&"
export * from "./Staff05.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports